<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string
  }>(),
  { label: "Cover" },
)
</script>

<template>
  <span
    class="absolute top-1 left-1 rounded bg-black/60 px-1.5 py-0.5 text-[10px] font-medium text-white"
  >
    {{ label }}
  </span>
</template>
